import { type ComponentProps, type ReactNode } from 'react';

import { cn } from '@/util/utils';

type StatTileProps = Omit<ComponentProps<'div'>, 'children'> & {
    label: ReactNode;
    value: ReactNode;
};

/** stat-tile, READ 192x60: a condensed label over an 18px value on the recessed surface. */
function StatTile({ label, value, className, ...props }: StatTileProps) {
    return (
        <div
            data-slot="stat-tile"
            className={cn('bg-muted flex min-w-0 flex-col gap-2 rounded-md px-3 py-2.5', className)}
            {...props}
        >
            <span className="text-label-sm text-muted-foreground">{label}</span>
            <span className="text-foreground text-lg leading-none">{value}</span>
        </div>
    );
}

export { StatTile, type StatTileProps };
